import { ModalsContext } from '@ws/shared/components';
import { TEntity } from '@ws/shared/types';
import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { EditabilityContext, ResolutionContext } from '../../context';
import { showEntityCreationModal } from '../../pages/EditorPage/ContentBoardContainer/EntityCreationModal';
import { TRouterKeys } from '../../types/router';
import { getProjectRoute } from '../../utils/routes';

export function useCreateNodes({ entity }: { entity: TEntity }) {
  const { projectId } = useParams<TRouterKeys>();
  const navigate = useNavigate();
  const { setModal } = useContext(ModalsContext);
  const { resolution } = useContext(ResolutionContext);
  const editability = useContext(EditabilityContext);

  const createNewNote = (name: string) => {
    const { id } = entity;
    const noteRef = editability.addNewNote({ parentId: id, name });

    return noteRef.id;
  };

  const handleCreateNoteClick = () => {
    const createAndGo = (name: string) => {
      const id = createNewNote(name);

      if (projectId) {
        navigate(getProjectRoute(projectId, id));
      }
    };
    const Modal = showEntityCreationModal('note', createNewNote, createAndGo, resolution);

    setModal({
      closeAfterAction: true,
      customView: Modal,
    });
  };

  const createNewCollection = (name: string) => {
    const { id } = entity;
    const collectionRef = editability.addNewCollection({ parentId: id, name });

    return collectionRef.id;
  };

  const handleCreateCollectionClick = () => {
    const createAndGo = (name: string) => {
      const id = createNewCollection(name);

      if (projectId) {
        navigate(getProjectRoute(projectId, id));
      }
    };
    const Modal = showEntityCreationModal(
      'collection',
      createNewCollection,
      createAndGo,
      resolution,
    );

    setModal({
      closeAfterAction: true,
      customView: Modal,
    });
  };

  return {
    handleCreateNoteClick,
    handleCreateCollectionClick,
  };
}
